module.exports = __webpack_public_path__ + "static/img/INF_g.876d1d65.png";